import type { Tables } from "@/integrations/supabase/types";
import type { ServiceContext } from "@prolarus/shared";
import { apiPost, ApiError } from "@/lib/apiClient";
import { tryCreate, tryDelete, tryGet, tryList, tryUpdate } from "./_shared";

type ApiKey = Tables<"api_keys">;

export interface ApiKeyCreateData {
  name: string;
  key_hash: string;
  key_prefix: string;
  scopes?: string[];
  expires_at?: string | null;
  is_active?: boolean;
}

export const apiKeyService = {
  getById(id: string) {
    return tryGet<ApiKey>(`/api/api-keys/${encodeURIComponent(id)}`);
  },
  list(_companyId: string) {
    return tryList<ApiKey>("/api/api-keys");
  },
  listActive(_companyId: string) {
    return tryList<ApiKey>("/api/api-keys?activeOnly=true");
  },
  create(data: ApiKeyCreateData, _context: ServiceContext) {
    return tryCreate<ApiKey>("/api/api-keys", data);
  },
  update(
    id: string,
    data: Partial<ApiKey>,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ) {
    return tryUpdate<ApiKey>(`/api/api-keys/${encodeURIComponent(id)}`, data);
  },
  toggleActive(
    id: string,
    isActive: boolean,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ) {
    return tryUpdate<ApiKey>(`/api/api-keys/${encodeURIComponent(id)}`, { is_active: isActive });
  },
  delete(id: string, _snapshot: Record<string, unknown>, _context: ServiceContext) {
    return tryDelete(`/api/api-keys/${encodeURIComponent(id)}`);
  },
  async updateLastUsed(id: string) {
    try {
      await apiPost(`/api/api-keys/${encodeURIComponent(id)}/touch`);
      return { error: null };
    } catch (err) {
      const e = err instanceof ApiError ? err : err instanceof Error ? err : new Error(String(err));
      return { error: e };
    }
  },
};
